/** Spanish for the My Hub hubOrdering area. Keys are the exact English strings the UI renders. */
const hubOrdering = {
  'New Customer': 'Nuevo cliente',
  'Customer list': 'Lista de clientes',
  'Customer pages': 'Páginas de clientes',
  'Showing {start}–{end} of {total}': 'Mostrando {start}–{end} de {total}',
  'Discard customer draft?': '¿Descartar el borrador del cliente?',
  'Closing discards this customer draft.': 'Al cerrar se descarta este borrador del cliente.',
  'No distributor customers yet. Select New Customer to get started.':
    'Aún no hay clientes del distribuidor. Seleccione Nuevo cliente para comenzar.',
  'Use 12-72 characters with uppercase and lowercase letters, a number, and one of @$!%*?&#.':
    'Use 12-72 caracteres con may\u00fasculas y min\u00fasculas, un n\u00famero y uno de @$!%*?&#.',
  'Account status could not be confirmed. Reload and review the current list before trying again.':
    'No se pudo confirmar el estado de la cuenta. Recargue y revise la lista actual antes de volver a intentarlo.',
  'Customer prices apply to new orders. Credit limits are informational. Orders use available tissue bank units.':
    'Los precios del cliente se aplican a los nuevos pedidos. Los l\u00edmites de cr\u00e9dito son informativos. Los pedidos utilizan las unidades disponibles del banco de tejidos.',
  'Read-only preview': 'Vista previa de solo lectura',
  'Browse this distributor workspace. Creating orders and changing accounts or settings are disabled.':
    'Explore este espacio de distribuidor. No se pueden crear pedidos ni cambiar cuentas o ajustes.',
  'No distributor customers yet.': 'Aún no hay clientes del distribuidor.',
  'Alerts appear when a product family first falls to 100 units or fewer.':
    'Las alertas aparecen cuando una familia de productos baja por primera vez a 100 unidades o menos.',

  'Distributor access': 'Acceso para distribuidores',
  'Distributor workspace': 'Espacio de distribuidores',
  'Distributor sections': 'Secciones del distribuidor',
  // Distributor sidebar pages and customer/order workspaces.
  'Tissue Bank': 'Banco de tejidos',
  'Tissue bank': 'Banco de tejidos',
  'Your customers, orders, and product bank at a glance.':
    'Sus clientes, pedidos y banco de productos de un vistazo.',
  'Manage your distributor customers and their account settings.':
    'Administre los clientes de su distribuidor y los ajustes de sus cuentas.',
  'Create orders and follow your distributor order history.':
    'Cree pedidos y consulte el historial de pedidos de su distribuidor.',
  'Review coverage requests for your distributor customers.':
    'Revise las solicitudes de cobertura de los clientes de su distribuidor.',
  'Follow tracking and delivery for your distributor orders.':
    'Consulte el seguimiento y la entrega de los pedidos de su distribuidor.',
  'View available product units, transactions, and low-bank alerts.':
    'Consulte las unidades de productos disponibles, las transacciones y los avisos de saldo bajo.',
  'Distributor overview page': 'Página de resumen del distribuidor',
  'Tissue bank page': 'Página del banco de tejidos',
  'Customer workspace': 'Espacio de clientes',
  '{count} customer': '{count} cliente',
  'Create customer': 'Crear cliente',
  'Customer name': 'Nombre del cliente',
  'Search customers': 'Buscar clientes',
  'No customers match your search.': 'Ningún cliente coincide con su búsqueda.',
  'No distributor customers yet. Create a customer above to get started.':
    'Aún no hay clientes del distribuidor. Cree un cliente arriba para comenzar.',
  'Distributor customer': 'Cliente del distribuidor',
  'Orders draw from your shared product bank.':
    'Los pedidos utilizan su banco de productos compartido.',
  'New order': 'Nuevo pedido',
  'Add a customer before creating an order.': 'Agregue un cliente antes de crear un pedido.',
  'Go to Customers': 'Ir a Clientes',
  'Choose a customer': 'Seleccione un cliente',
  'Select customer': 'Seleccionar cliente',
  'Change customer': 'Cambiar cliente',
  'Keep this order open until its result is confirmed. Retry uses the same request.':
    'Mantenga este pedido abierto hasta confirmar el resultado. Al reintentar se utiliza la misma solicitud.',
  'Discard order draft?': '¿Descartar el borrador del pedido?',
  'Changing customers discards this unsubmitted order draft.':
    'Al cambiar de cliente se descarta este borrador de pedido sin enviar.',
  'Discard draft': 'Descartar borrador',
  'Distributor activity': 'Actividad del distribuidor',
  'Loading activity...': 'Cargando actividad...',
  'No {kind} yet.': 'Aún no hay {kind}.',
  'Showing {shown} of {total}': 'Mostrando {shown} de {total}',
  'Activity detail': 'Detalle de actividad',
  'Manage clinics, orders, and product bank.':
    'Administre cl\u00ednicas, pedidos y el banco de productos.',
  // Distributor order address entry and one-order overrides.
  'Delivery address': 'Direcci\u00f3n de entrega',
  'Delivery street address': 'Direcci\u00f3n de entrega',
  'Enter a complete delivery address before ordering.':
    'Ingrese una direcci\u00f3n de entrega completa antes de realizar el pedido.',
  'Prefilled from this clinic. Changes apply to this order only.':
    'Se complet\u00f3 con la direcci\u00f3n de esta cl\u00ednica. Los cambios solo se aplican a este pedido.',
  'Enter a delivery address for this order. Changes apply to this order only.':
    'Ingrese una direcci\u00f3n de entrega para este pedido. Los cambios solo se aplican a este pedido.',
  'Your master distributor submits banked orders for this clinic.':
    'Su distribuidor principal envía los pedidos de este consultorio usando el banco de productos.',
  // Orders page + New Order form, clinic login whose rep switched ordering off
  'Ordering is turned off for your clinic. Your sales representative places orders for you - you can still see every order here.':
    'El envío de pedidos está desactivado para su clínica. Su representante de ventas realiza los pedidos por usted; aquí puede seguir viendo todos los pedidos.',
  // New Order form, clinic login with a product allow-list
  'Your sales representative limited this clinic to {n} product':
    'Su representante de ventas limitó esta clínica a {n} producto',
  'Your sales representative limited this clinic to {n} products':
    'Su representante de ventas limitó esta clínica a {n} productos',

  // Admin Clinics tab: credit limit column
  'CREDIT LIMIT': 'LÍMITE DE CRÉDITO',
  'Credit limit for {name}': 'Límite de crédito de {name}',
  'Failed to save credit limit': 'No se pudo guardar el límite de crédito',
  // Admin Clinics tab: My Hub badges and row button
  'Ordering off': 'Pedidos desactivados',
  '{n} product': '{n} producto',
  '{n} products': '{n} productos',
  'Open in My Hub': 'Abrir en Mi centro',
  'This clinic is not listable in My Hub - confirm it as a practice first.':
    'Esta clínica no aparece en Mi centro; confírmela primero como consultorio.',
  'Could not load My Hub for this clinic.': 'No se pudo cargar Mi centro para esta clínica.',

  // Server sentences an order submission can come back with
  'Ordering is turned off for this clinic. Ask your MedEffects sales representative to place the order.':
    'El envío de pedidos está desactivado para esta clínica. Pida a su representante de ventas de MedEffects que realice el pedido.',
  // Credit-limit cell (admin Clinics tab): the server's own refusals.
  'The credit limit is larger than any plausible limit. Check the number.':
    'El límite de crédito es mayor que cualquier límite razonable. Revise el número.',
  'The credit limit cannot be negative.': 'El límite de crédito no puede ser negativo.',
  'The credit limit must be a number of dollars, or null to clear it.':
    'El límite de crédito debe ser una cantidad en dólares, o nulo para borrarlo.',
  'Only an administrator can set a clinic credit limit.':
    'Solo un administrador puede establecer el límite de crédito de una clínica.',
  'Send creditLimit as a number of dollars, or null to clear it.':
    'Envíe creditLimit como una cantidad en dólares, o nulo para borrarlo.',
};

export default hubOrdering;
